import React, { useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import RegulatoryUpdateBundleLoggedInPopup from './RegulatoryUpdateBundleLoggedInPopup';
import RegulatoryUpdateBundleLoggedOutPopup from './RegulatoryUpdateBundleLoggedOutPopup';
import { actionData } from '../../utils/regulatoryUpdatesBundle';
type PrivacyPolicyPopupProps = {
  setClosePopup: Function;
};

const PrivacyPolicyPopup = (props: PrivacyPolicyPopupProps): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const loggedIn = globalContext.customer.uuid;
  const triggerActionGaEvent = (actionValue): void => {
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      actionValue === actionData.RETRIEVE
        ? 'ClickRetrieveDataCheckbox'
        : 'ClickDeleteDataCheckbox',
      '',
      null,
      true
    );
  };

  useEffect(() => {
    globalContext.gtm.setVirtualPage(
      loggedIn
        ? 'Privacy_Request_View_Modal_Logged_In'
        : 'Privacy_Request_View_Modal_Logged_Out'
    );
  }, []);

  if (loggedIn) {
    return (
      <RegulatoryUpdateBundleLoggedInPopup
        setClosePopup={props.setClosePopup}
        triggerActionGaEvent={triggerActionGaEvent}
      />
    );
  }

  return (
    <RegulatoryUpdateBundleLoggedOutPopup
      setClosePopup={props.setClosePopup}
      triggerActionGaEvent={triggerActionGaEvent}
    />
  );
};

export default PrivacyPolicyPopup;
